module.exports = __webpack_public_path__ + "static/media/997100.2e01b308.png";